"use client";
import { Accordion as e } from "./accordion.js";
export {
  e as Accordion
};
